import { render, staticRenderFns } from "./DropDown.vue?vue&type=template&id=4489d516&scoped=true&"
import script from "./DropDown.vue?vue&type=script&lang=ts&"
export * from "./DropDown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4489d516",
  null
  
)

export default component.exports